import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import { Popover } from 'react-bootstrap';

// idroslab
function Data_formattata(newDate, minuti) {
    //  console.log('aaaaaaaaaaaaaaaaaaaaaaa')
    //  console.log(newDate)
      
      let dateVariable = new Date(newDate);
      if (dateVariable == 'Invalid Date') {
    
         console.log('NON DATA ')
         
         return ''
      }
    
      const months = {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December',
      }
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const d = newDate
    //  console.log('YYYYYYYYYYYYYYYYYYYYYYYYYYYYY  NON DATA ')
      
      const year = dateVariable.getFullYear()
      const date = dateVariable.getDate()
      const monthIndex = dateVariable.getMonth()
      const monthName = months[dateVariable.getMonth()]
      const dayName = days[dateVariable.getDay()] // Thu
      const hour = dateVariable.getHours() 
      const minute = dateVariable.getMinutes() 
   
      let  formatted = ` ${hour}:${minute} `
      if (minuti > 24*60) {
        let giorni = minuti / (24*60)
       
        giorni = Math.floor(giorni) 
        formatted = ` ${hour}:${minute} (${giorni} giorno/i dopo) `

       }
      return formatted.toString()
    } 


    function calcola_ore_minuti(minuti) {
        //  console.log('aaaaaaaaaaaaaaaaaaaaaaa')
        //  console.log(newDate)
          
        //  console.log('YYYYYYYYYYYYYYYYYYYYYYYYYYYYY  NON DATA ')
          
        let giorni = 0
        let ore = 0
        let minuti_rimanenti = minuti 
       
        if (minuti_rimanenti > 24*60) {
             giorni = minuti_rimanenti / (24*60)
            
             giorni = Math.floor(giorni) 

             minuti_rimanenti = minuti_rimanenti - (giorni * 24 * 60)
        }
        if (minuti_rimanenti > 60) {
            ore = minuti_rimanenti / (60)
            ore = Math.floor(ore) 
            minuti_rimanenti = minuti_rimanenti - (ore * 60)
       }
       
        minuti_rimanenti = Math.floor(minuti_rimanenti) 
           
        let formatted = ` ${ore} ore ${minuti_rimanenti} minuti `
        if (giorni > 0) {formatted = ` ${giorni} giorno/i, ${ore} ore ${minuti_rimanenti} minuti`}

        return formatted.toString()
    } 
    



const Presenze_tooltip = (props) => {
//    const [somma, calcola_somma] = useState('');
console.log('ciaossssss')

    const mystyle = {
        color: "white",
        backgroundColor: "DodgerBlue",
        width: "max-content"
        
    };

    return (
        <Popover id="popover-basic">
        <Popover.Header as="h3">Invio mail</Popover.Header>
        <Popover.Body>
        <div style={mystyle}>
         
<ul>
              <li>
              Ora di invio della mail: {Data_formattata(props.tempo_inviomail,0)}
              </li>
              <li>
              Ora di risposta: {Data_formattata(props.tempo_risposta, props.minuti)}
              </li>
              <li>
                 Differenza: {calcola_ore_minuti(props.minuti)} 
              </li>

              </ul>                                  
              </div>
        </Popover.Body>
      </Popover>
      
    )
}
export default Presenze_tooltip;